module.exports = __webpack_public_path__ + "static/media/master.8bf31bcc.svg";